module.exports = __webpack_public_path__ + "static/media/AI-转接-屏幕-摄像头-新.12629fac.jpg";